import { Observable, Subject } from 'rxjs';
import { AfterViewChecked, Component, OnInit, ViewEncapsulation } from '@angular/core';

import { IToastConfig } from '../interfaces';

@Component({
    selector: 'odd-toast',
    templateUrl: './toast.component.html',
    host: {
        class: 'odd-alert'
    },
    encapsulation: ViewEncapsulation.None
})

export class ToastComponent implements OnInit, AfterViewChecked {
    public open = false;
    public config: IToastConfig;

    private timer: any;
    private doCheckCalled: boolean;
    private afterClosed$: Subject<any> = new Subject();

    public ngOnInit() {
        setTimeout(() => this.open = true, 180);

        if (this.config.duration > 0) {
            this.timer = setTimeout(() => this.dismiss(), this.config.duration);
        }
    }

    public ngAfterViewChecked(): void {
        if (this.doCheckCalled) {
            let top = 0;
            const tops = [0];

            for (let i = document.querySelectorAll('.alert').length; i > 0 ; i--) {
                tops.push((document.querySelectorAll('.alert') as any)[i - 1].clientHeight + 10);
            }

            let index = 0;
            for (let i = document.querySelectorAll('.alert').length; i > 0 ; i--) {
                top += tops[index++];
                document.querySelectorAll('.alert')[i - 1].setAttribute('style', `top: ${ top }px`);
            }

            this.doCheckCalled = false;
        } else {
            this.doCheckCalled = true;
        }
    }

    public dismiss() {
        this.open = false;

        setTimeout(() => {
            (this.config as any).dismiss();

            this.afterClosed$.next(true);
            this.afterClosed$.complete();
        }, 200);
    }

    public afterClosed(): Observable<any> {
        return this.afterClosed$.asObservable();
    }
}
